import { EditorSimpleSelect } from "./editor-simple-select";
import { Feature, LineString, MultiPolygon, Point, Polygon, Position } from "geojson";
import { GeometryUtil } from "../../geometry";
import { VueMapPopup } from "../../control/VueMapPopup";
import { defineAsyncComponent } from "vue";
import { FeatureUtil } from "../../feature";
import { DrawFeature } from "@mapbox/mapbox-gl-draw";
import { InteractionState } from "../abstract-interaction";
import { ViewSimpleSelect } from "../view/view-simple-select";
import { MapEvent } from "../../../document/model/map";
import {mapboxglref} from "@/js/mapboxService";

let MapInputNumberMarker = defineAsyncComponent(() => import("../../../../components/map/markers/MapInputNumber.vue"));

export class OffsetInteractionState extends InteractionState {
  offset: number;
}

export class EditorOffsetLine extends ViewSimpleSelect<OffsetInteractionState> {
  public mapboxgl = mapboxglref();
  private offsetLine: DrawFeature | undefined;
  private offsetInput: VueMapPopup<typeof MapInputNumberMarker> | undefined;

  buildInitialState(options: any): any {
    let state: OffsetInteractionState = super.buildInitialState(options);

    this.offsetInput = new VueMapPopup<typeof MapInputNumberMarker>(MapInputNumberMarker, {
      initialValue: 0,
      step: 5,
      styleclass: 'map-input-number-lg',
      suffix: ' m',
      onInput: (value: number) => {
        this._updateOffsetLine(value);
        if (!state.isDirty) {
          this.controller.interaction.historyPush(state);
        }
        this.tick();
      }
    });
    this.offsetInput.addTo(this.controller.mapInstance);
    let center = GeometryUtil.center(state.features.get(state.featureID));

    this.offsetInput.setLngLat(new this.mapboxgl.LngLat(center[0], center[1]));

    return state;
  }

  onStop(state: OffsetInteractionState) {
    this.offsetInput.remove();
    this.offsetInput = undefined;

    if (this.offsetLine) {
      this.removeDrawFeature(this.offsetLine.id.toString());
      this.offsetLine = undefined;
    }
  }

  canSave(state: OffsetInteractionState): boolean {
    return this.controller.interaction.hasHistory();
  }

  save(state: OffsetInteractionState, nextInteraction: string | undefined = undefined) {
    this.createLayerGeometries([
      GeometryUtil.lineString(this.offsetLine.getCoordinates() as Position[])
    ])
  }

  private _updateOffsetLine(offset: number, state: OffsetInteractionState | undefined = undefined): void {
    state = state ?? this.mode.currentInteractionState as OffsetInteractionState;
    this.offsetLine = this.createFeature(
        FeatureUtil.lineOffset(
            state.features.get(state.featureID) as Feature<LineString>,
            offset
        )
    );
    // @ts-ignore
    this.offsetLine.id = 'offset_line';
    this.displayDrawFeature(this.offsetLine);
  }
}